module.exports = __webpack_public_path__ + "images/corners/Palamino.88354052ad270022feb4baf30e35ae3f.jpg";